<template>
  <v-progress-circular
    :size="size"
    :width="width"
    class="circular-progress"
    indeterminate
  />
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps({
  width: {
    type: Number,
    default: 4,
  },
  size: {
    type: Number,
    default: 32,
  },
});

const { width, size } = toRefs(props);
</script>

<style lang="scss" scoped>
@use "../../styles/responsive";
@use "../../styles/variables";

.circular-progress {
  :deep(.v-progress-circular__overlay) {
    stroke: variables.$mid-orange;
  }
}
</style>
